var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopupWithInfo
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v("Pridanie spolužiadateľa")])]), _c('div', {
    staticClass: "client-name-block"
  }, [_c('img', {
    staticClass: "image-10",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f37_avatar%20cropped.png",
      "loading": "lazy",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "div-block-28"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.clientInfo.type))])])]), _c('client-picker', {
    attrs: {
      "disabled": _vm.saving,
      "complex": ""
    },
    on: {
      "client-picked": function clientPicked($event) {
        _vm.selectedClient = $event;
      },
      "busy": function busy($event) {
        _vm.clientBusy = $event;
      }
    }
  }), _vm.saveError ? _c('p', {
    staticClass: "clientError",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.saveError))]) : _vm._e(), _c('button', {
    staticClass: "w-button",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedClient || _vm.saving || _vm.clientBusy
    },
    on: {
      "click": function click($event) {
        return _vm.assignCoApplicant(_vm.selectedClient);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.saving ? 'Pridávam…' : 'Pridať spolužiadateľa') + " ")])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }